import axios from 'axios';
import { logger } from '@/utils/logger';
import { env } from '@zopauk/nextjs-env';
import { initializeMembershipHubApi } from '@zopauk/api-membership-hub';
import { correlationInterceptor, loggerInterceptor, csrfInterceptor } from '@zopauk/libs-axios';

const isDev = env('NEXT_PUBLIC_APP_ENV') === 'development';

export const setMembershipApiConfig = () => {
  let instance = axios.create({
    withCredentials: true,
  });

  instance = initializeMembershipHubApi(instance);

  csrfInterceptor({ instance });
  correlationInterceptor({ instance });
  loggerInterceptor({
    identifier: 'MEMBERSHIP API',
    verbose: isDev,
    instance,
    logger,
  });

  return instance;
};
